/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { IStackItemStyles } from '@fluentui/react/lib/Stack';
import { CSSProperties } from 'react';
import { getAppHost } from '../../../../../utilities/TeamsUtils';
import { getHTMLDir } from '../../../../../utilities/Utils';

export const getHeaderStyles = (): Partial<CSSProperties> => {
    const isRtl = getHTMLDir(getAppHost().getLocaleName()) === 'rtl';
    return {
        paddingTop: '1.7rem',
        paddingBottom: '0.5rem',
        paddingLeft: isRtl ? '3.5rem' : '2rem',
        paddingRight: isRtl ? '2rem' : '3.5rem',
    };
};

export const getBodyStyles = (): Partial<CSSProperties> => ({
    padding: '0 2rem',
    overflowX: 'hidden',
    overflowY: 'auto',
    flexGrow: 1,
    margin: '1rem 0 2rem 0',
});

export const getFooterStyles = (): Partial<IStackItemStyles> => ({
    root: {
        padding: '0 2rem 2.3rem 2rem',
    },
});

export const getTemplatePreviewIframeWrapperStyles = (height: number): Partial<IStackItemStyles> => ({
    root: {
        height,
        overflow: 'hidden',
        // left/right margin because form iframe has 8px margin on horizontal direction
        // to keep margin aligned with our inputs, we add these negative pixels
        margin: '0 -8px',
        width: 'auto',
        position: 'relative',
    },
});

export const getTemplatePreviewIframeStyles = (): Partial<CSSProperties> => ({
    width: '100%',
    height: '100%',
    overflow: 'hidden',
});

export const getConditionPageWrapperStyles = (): Partial<CSSProperties> => {
    return {
        width: '100%',
        position: 'absolute',
    };
};
